import { useMemo } from "react";
import {
  ListChecks,
  MapPinHouse,
  MessageSquare,
  Search,
  Sparkles,
} from "lucide-react";

import { ConversationPhase, MessageType } from "shared/types";
import { getText } from "shared/lib";

import { useAccount, useFindMessageOfType, useLatestMessage } from "@/hooks";

import { ConversationProgressIndicator } from "shared/components";

export function ConversationProgressHeader() {
  const { conversation } = useAccount();

  const latestMessage = useLatestMessage();

  const siteOverviewMessage = useFindMessageOfType({
    messageType: MessageType.SITE_OVERVIEW,
  });
  const finaliseDetailsMessage = useFindMessageOfType({
    messageType: MessageType.FINALISE_DETAILS,
  });
  const reviewProposalMessage = useFindMessageOfType({
    messageType: MessageType.REVIEW_PROPOSAL,
  });
  const routingQuestionMessage = useFindMessageOfType({
    messageType: MessageType.ROUTING_QUESTION,
  });

  const currentStage = useMemo(() => {
    if (
      routingQuestionMessage ||
      conversation?.phase === ConversationPhase.ready_for_assessment
    ) {
      return "analysis";
    }
    if (
      siteOverviewMessage &&
      siteOverviewMessage.message_number === latestMessage?.message_number
    ) {
      return "site_overview";
    }
    if (
      finaliseDetailsMessage &&
      finaliseDetailsMessage.message_number === latestMessage?.message_number
    ) {
      return "finalise_details";
    }
    if (
      reviewProposalMessage &&
      reviewProposalMessage.message_number === latestMessage?.message_number
    ) {
      return "review_proposal";
    }
    return "describe_proposal";
  }, [
    conversation?.phase,
    finaliseDetailsMessage,
    latestMessage?.message_number,
    reviewProposalMessage,
    routingQuestionMessage,
    siteOverviewMessage,
  ]);

  return (
    <ConversationProgressIndicator
      currentStage={currentStage}
      stages={[
        {
          label: getText("Site overview"),
          key: "site_overview",
          icon: <MapPinHouse className="h-3 w-3" />,
        },
        {
          label: getText("Describe proposal"),
          key: "describe_proposal",
          icon: <MessageSquare className="h-3 w-3" />,
        },
        {
          label: getText("Finalise details"),
          key: "finalise_details",
          icon: <Search className="h-3 w-3" />,
        },
        {
          label: getText("Review proposal"),
          key: "review_proposal",
          icon: <ListChecks className="h-3 w-3" />,
        },
        {
          label: getText("Analysis"),
          key: "analysis",
          icon: <Sparkles className="h-3 w-3" />,
        },
      ]}
    />
  );
}
